import * as React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import * as moment from 'moment';
import * as $ from 'jquery';
import { Grid, GridColumn as Column, GridCell } from '@progress/kendo-react-grid';
import { DatePicker } from '@progress/kendo-react-dateinputs';
import { DropDownList, DropDownListChangeEvent } from '@progress/kendo-react-dropdowns';
import { NumericTextBox } from '@progress/kendo-react-inputs';
import { fetchApi } from '../../services/api';
import LoadingButton from '../LoadingButton';
import InvoiceDropDown, { InvoiceSearchResult } from '../InvoiceDropDown';

type Props = RouteComponentProps<{
    accountId: string;
 }>;

type State = {
    accountId: number;
    payments: Payment[];
    facilities: IDName[];
    isLoading: boolean;
    isSaving: boolean;
    validation: boolean;

    facilityID: undefined|number;
    ReversePaymentId: number;
    source: undefined|number;
    amount: number | null;
    comment: string;
    invoiceId: number;
    date: Date | null;
    chargeDescription: string;
    publishableKey: string;
}

export interface Payment {
    PaymentId: number;
    Source: number;
    Amount: number;
    Comment: string;
    Date: Date;
    IsReversed: boolean;
}

export interface IDName {
    ID: number;
    Name: string;
}

class SourceCell extends GridCell {
    render() {
        return (
            <td>{this.GetSourceName(this.props.dataItem.Source)}</td>
        );
    }

    private GetSourceName(source: number): string {
        switch (source) {
            case 0:
                return 'Cash';
            case 1:
                return 'Cheque';
            case 2:
                return 'e-Transfer';
            case 3:
                return 'Credit Card';
            case 4:
                return 'Reversed';
            case 5:
                return 'Discount';
            default:
                return 'Unknown';
        }
    }
}

class DateCell extends GridCell {
    render() {
        if (!this.props.field) return null;

        return (
            <td>{moment.utc(this.props.dataItem[this.props.field]).local().format("YYYY-MM-DD")}</td>
        );
    }
}

export default class AccountPayments extends React.Component<Props, State> {

    CommandCell: typeof GridCell;

    paymentTypes = [
        { text: 'Cash', value: 0 },
        { text: 'Cheque', value: 1 },
        { text: 'e-Transfer', value: 2 },
        { text: 'Credit Card', value: 3 },
        { text: 'Discount', value: 5 }
    ];

    constructor(props: Props) {
        super(props);

        this.state = {
            accountId: 0,
            payments: [],
            facilities: [],
            isLoading: false,
            isSaving: false,
            validation: false,

            facilityID: undefined,
            ReversePaymentId: 0,
            source: -1,
            amount: 0,
            comment: '',
            invoiceId: -1,
            date: new Date(),
            chargeDescription: '',
            publishableKey: '',
        };

        this.chargeCreditCard = this.chargeCreditCard.bind(this);
        this.save = this.save.bind(this);
        this.handleFacilityChange = this.handleFacilityChange.bind(this);
        this.handleSourceChange = this.handleSourceChange.bind(this);
        this.getPayments = this.getPayments.bind(this);
        this.reverse = this.reverse.bind(this);
        const setReversePaymentId = this.setReversePaymentId.bind(this);

        class ReverseCell extends GridCell {
            render() {
                if (this.props.dataItem.Source === 4 || this.props.dataItem.IsReversed) return <td/>;
                return (
                    <td><button type="button" className="btn btn-danger k-grid-remove-command" data-toggle="modal" data-target=".reverse-modal" onClick={() => setReversePaymentId(this.props.dataItem.PaymentId)}>Reverse</button></td>
                );
            }
        }

        this.CommandCell = ReverseCell;
    }

    public componentWillMount() {
        // This method runs when the component is first added to the page
        let accountId = parseInt(this.props.match.params.accountId) || 0;
        this.getPayments(accountId);
    }

    public componentWillReceiveProps(nextProps: Props) {
        // This method runs when incoming props (e.g., route params) change
        let accountId = parseInt(nextProps.match.params.accountId) || 0;

        if (this.state.payments && this.state.accountId != accountId) {
            this.getPayments(accountId);
        }
    }

    public render() {
        return <div>
            <br />
            <div className="row">
                <div className="col">
                    <h1>Payments</h1>
                </div>
                <div className="col">
                    <button type="button" className="btn btn-primary float-right" data-toggle="modal" data-target=".bd-example-modal-lg">Add Payment</button>
                    <div id="paymentModal" className="modal fade bd-example-modal-lg" tabIndex={-1} role="dialog">
                        <div className="modal-dialog modal-lg" role="document">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title">Add Payment</h5>
                                    <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    <div className="form-group">
                                        <DropDownList
                                            data={this.state.facilities}
                                            textField={'Name'}
                                            defaultItem={{ Name: 'Facility', ID: -1 }}
                                            value={this.state.facilities.find(x => x.ID === this.state.facilityID)}
                                            onChange={this.handleFacilityChange}
                                        />
                                        {this.state.validation && (this.state.facilityID === -1 || this.state.facilityID === undefined) && <p className="error-msg">Please select Facility</p>}
                                    </div>
                                    <div className="form-group">
                                        <DropDownList
                                            data={this.paymentTypes}
                                            textField={'text'}
                                            defaultItem={{ text: 'Payment Type', value: -1 }}
                                            value={this.paymentTypes.find(x => x.value === this.state.source)}
                                            onChange={this.handleSourceChange}
                                        />
                                        {this.state.validation && (this.state.source === -1 || this.state.source === undefined) && <p className="error-msg">Please select Payment Type</p>}
                                    </div>
                                    <div className="form-group">
                                        <NumericTextBox
                                            defaultValue={this.state.amount}
                                            format="c2"
                                            min={0}
                                            value={this.state.amount}
                                            onChange={(e) => this.setState({ amount: e.value })}
                                        />
                                        {this.state.validation && !this.state.amount && <p className="error-msg">Please enter Amount</p>}
                                    </div>
                                    <div className="form-group">
                                        <InvoiceDropDown
                                            callbackFromParent={this.myInvoiceCallback}
                                            accountId={this.state.accountId}
                                            className={"form-control"}
                                        />
                                    </div>
                                    <div className="form-group">
                                        <input
                                            className="form-control"
                                            type="text"
                                            placeholder="Description of Charge"
                                            value={this.state.chargeDescription}
                                            onChange={(e) => this.setState({ chargeDescription: e.target.value })}
                                        />
                                    </div>
                                    <div className="form-group">
                                        <input
                                            className="form-control"
                                            type="text"
                                            placeholder="Cheque #, etc"
                                            value={this.state.comment}
                                            onChange={(e) => this.setState({ comment: e.target.value })}
                                        />
                                    </div>
                                    <div className="form-group">
                                        <DatePicker
                                            format="MM/dd/yyyy"
                                            formatPlaceholder="formatPattern"
                                            value={this.state.date}
                                            onChange={(e) => this.setState({ date: e.value })}
                                        />
                                        {this.state.validation && this.state.date === null && <p className="error-msg">Please enter Date</p>}
                                    </div>
                                    <LoadingButton className="btn btn-success" onClick={this.save} isLoading={this.state.isSaving}>Add Payment</LoadingButton>
                                    {/* Only display the credit card button if they have a publishable key (stripe account) */}
                                    {this.state.publishableKey && <React.Fragment>
                                        <button className="btn btn-primary" onClick={this.chargeCreditCard} style={{ marginLeft: 10 }}>Credit Card Charge</button>
                                    </React.Fragment>}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div id="reverseModal" className="modal fade reverse-modal" tabIndex={-1} role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">
                        <div className="modal-dialog modal-lg" role="document">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h4 className="modal-title">Reverse Payment</h4>
                                    <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    <div className="form-group">
                                        <p>Comment</p>
                                        <input
                                            className="form-control"
                                            type="text"
                                            placeholder="Cheque #, etc"
                                            value={this.state.comment}
                                            onChange={(e) => this.setState({ comment: e.target.value })}
                                        />
                                    </div>
                                    <br/>
                                    <button className="btn btn-danger" onClick={this.reverse}>Reverse Payment</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Grid data={this.state.payments} scrollable='none'>
                <Column field="Source" title="Payment Type" cell={SourceCell} />
                <Column field="Amount" format="{0:c}" filter="numeric" />
                <Column field="Comment" />
                <Column field="Date" cell={DateCell} filter="date" />
                <Column field="Reverse" cell={this.CommandCell} />
            </Grid>
        </div>;
    }

    private myInvoiceCallback = (result: InvoiceSearchResult) => {
        this.setState({
            amount: (result.InvoiceID == -1) ? 0 : result.Amount,
            invoiceId: result.InvoiceID
        });
    };

    private handleSourceChange(e: DropDownListChangeEvent) {
        this.setState({ source: e.target.value.value });
    }

    private handleFacilityChange(e: DropDownListChangeEvent) {
        this.setState({ facilityID: e.target.value.ID });
    }

    private getPayments(accountId: number) {
        this.setState({ isLoading: false, accountId });
        fetchApi(`api/Account/Payments/${accountId}`)
            .then((response: { Payments: Payment[], Facilities: IDName[], PublishableKey: string }) => {
                this.setState({
                    isLoading: false,
                    payments: response.Payments,
                    facilities: response.Facilities,
                    facilityID: parseInt(localStorage.getItem("FACILITY_ID") || "0") || undefined,
                    publishableKey: response.PublishableKey,
                });
            });
    }

    private setReversePaymentId(PaymentId: number) {
        this.setState({ ReversePaymentId: PaymentId })
    }

    private save() {

        if (this.state.facilityID === -1 || this.state.source === -1 || !this.state.amount || this.state.date === null) {
            this.setState({ validation: true })
            return;
        }

        this.setState({ isSaving: true });

        const data = {
            FacilityID: this.state.facilityID,
            Source: this.state.source,
            Amount: this.state.amount,
            Comment: this.state.comment,
            Date: this.state.date,
            InvoiceId: this.state.invoiceId
        }

        fetchApi(`api/Account/AddPayment/${this.state.accountId}`, data, 'POST')
            .then(() => {
                $("#paymentModal").modal('hide');
                this.setState({ amount: 0, comment: '', validation: false, isSaving: false });
                this.getPayments(this.state.accountId);
            });
    }

    private chargeCreditCard()
    {
        if (this.state.facilityID === -1 || this.state.source === -1 || !this.state.amount || this.state.date === null) {
            this.setState({ validation: true })
            return;
        }

        const data = {
            FacilityID: this.state.facilityID,
            Source: this.state.source,
            Amount: this.state.amount,
            Comment: this.state.comment,
            ChargeDescription: this.state.chargeDescription,
            Date: this.state.date,
            InvoiceId: this.state.invoiceId
        }

        fetchApi(`api/Account/CreateStripeSession/${this.state.accountId}`, data, 'POST')
            .then((response) => {
                console.log(response);
                var stripe = Stripe(this.state.publishableKey)
                stripe.redirectToCheckout({
                    sessionId: response.sessionId
                }).then((result : any) => {
                    console.log(result);
                });
            });
    }

    private reverse() {
        const data = {
            PaymentId: this.state.ReversePaymentId,
            Comment: this.state.comment,
        }

        fetchApi(`api/Account/ReversePayment`, data, 'POST')
            .then(() => {
                $("#reverseModal").modal('hide');
                this.setState({ comment: '', ReversePaymentId: 0 });
                this.getPayments(this.state.accountId);
            });
    }
}
